export default "__VITE_ASSET__LtJqqRrI__"